import { SELECIONAR_REPASSE } from '../types';

export default function selecionarRepasse (data) {
  return {
    type: SELECIONAR_REPASSE,
    payload: data
  }
}
